import { createStore } from '@stencil/store';

// Create the store
const { state } = createStore<Record<string, string>>({});

// Export the state
export const pathStore = state;
